<template>
  <div class="editor-styled">
    <slot />
  </div>
</template>

<style scoped>
/* Basic editor styles */
.editor-styled :deep(div[contenteditable='true']) {
  border: none;
  background-color: transparent;
  outline: none;
}

.editor-styled code {
  background-color: #f4f6f8;
  border-radius: 5px;
  padding: 5px 5px;
}

.editor-styled :deep(.has-focus) {
  border-radius: 3px;
  box-shadow: 0 0 0 3px #00ab55;
  padding: 5px 5px;
}

/* Color swatches */
.editor-styled :deep(.color) {
  white-space: nowrap;
}

.editor-styled :deep(.color::before) {
  content: ' ';
  display: inline-block;
  width: 1em;
  height: 1em;
  border: 1px solid rgba(128, 128, 128, 0.3);
  vertical-align: middle;
  margin-right: 0.1em;
  margin-bottom: 0.15em;
  border-radius: 2px;
  background-color: var(--color);
}

/* Placeholder */
.editor-styled :deep(.ProseMirror ul) {
  list-style-type: disc;
}

.editor-styled :deep(.ProseMirror) ol {
  list-style-type: decimal;
}

.editor-styled :deep(.ProseMirror p.is-editor-empty:first-child::before) {
  content: attr(data-placeholder);
  float: left;
  color: #adb5bd;
  pointer-events: none;
  height: 0;
}

/* Drag handles */
.editor-styled :deep(.draggable-item) {
  display: flex;
  padding: 0.5rem;
  margin: 0.5rem 0;
  border-radius: 0.5rem;
  cursor: grab;
  transition: 300ms;
}

.editor-styled :deep(.draggable-item:hover) {
  background: white;
  box-shadow:
    0 0 0 1px rgba(0, 0, 0, 0.05),
    0px 10px 20px rgba(0, 0, 0, 0.1);
}

.editor-styled :deep(.draggable-item .drag-handle) {
  flex: 0 0 auto;
  position: relative;
  top: 0.3rem;
  margin-right: 0.5rem;
  cursor: grab;
  background-image: url("data:image/svg+xml;charset=UTF-8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 16'><path fill-opacity='0.2' d='M4 14c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zM2 6C.9 6 0 6.9 0 8s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6C.9 0 0 .9 0 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' /></svg>");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.editor-styled :deep(.draggable-item .content) {
  flex: 1 1 auto;
}

/* ProseMirror content */
.editor-styled :deep(.ProseMirror) > * + * {
  margin-top: 1em;
}

.editor-styled :deep(.ProseMirror) img {
  max-width: 100%;
  height: auto;
  margin: auto;
}

.editor-styled :deep(.ProseMirror) img.ProseMirror-selectednode {
  outline: 3px solid #00ab55;
}

.editor-styled :deep(.ProseMirror) blockquote {
  padding-left: 1rem;
  border-left: 2px solid #00ab55;
}

.editor-styled :deep(.ProseMirror) ul,
.editor-styled :deep(.ProseMirror) ol {
  padding: 0 1.5rem;
}

.editor-styled :deep(.ProseMirror) h1 {
  font-size: 2.5em;
  line-height: 1.2;
  margin-bottom: 1rem;
}

.editor-styled :deep(.ProseMirror) h2 {
  font-size: 2em;
  line-height: 1.3;
  margin-bottom: 0.8rem;
}

.editor-styled :deep(.ProseMirror) h3 {
  font-size: 1.5em;
  line-height: 1.4;
  margin-bottom: 0.6rem;
}

.editor-styled :deep(.ProseMirror) h4 {
  font-size: 1.25em;
  line-height: 1.4;
  margin-bottom: 0.5rem;
}

.editor-styled :deep(.ProseMirror) h5,
.editor-styled :deep(.ProseMirror) h6 {
  font-size: 1em;
  line-height: 1.5;
  margin-bottom: 0.4rem;
}

.editor-styled :deep(.ProseMirror) code {
  background-color: rgba(97, 97, 97, 0.1);
  color: #616161;
}

.editor-styled :deep(.ProseMirror) pre {
  background: #0d0d0d;
  color: #fff;
  font-family: 'JetBrainsMono', monospace;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
}

.editor-styled :deep(.ProseMirror) pre code {
  color: inherit;
  padding: 0;
  background: none;
  font-size: 0.8rem;
}

.editor-styled :deep(.ProseMirror) hr {
  border-top: 1px solid #0d0d0d;
  margin: auto;
  width: 50%;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
